/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class DocumentationModel {

        private processConfigId: string;

        private $location: ng.ILocationService;
        private $anchorScroll: ng.IAnchorScrollService;
        private $scope: ng.IScope;
        private $rootScope: ng.IRootScopeService;

        private processConfigurationService: services.ProcessConfigurationService;
        private processTypeService: services.ProcessTypeService;
        private workflowService: services.WorkflowService;
        private workflowDrawingService: services.WorkflowDrawingService;
        private conditionService: services.ConditionService;
        private emailConfigurationService: services.EmailConfigurationService;
        private pdfBindingService: services.PdfBindingService;

        private modalService: any;

        public processType: Wars.Domain.Model.ProcessType;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public processStatusGroupResult: models.StatusGroupResult;
        public statusGroups: models.StatusGroup[];
        public conditions: Wars.Domain.Model.Conditions.Condition[];
        public emailConfigurations: Wars.Domain.Model.EmailConfiguration[];
        public pdfBindings: Wars.Domain.Model.PdfBinding[];
        

        constructor(
            processConfigId: string,
            anchor: string,
            $location: ng.ILocationService,
            $anchorScroll: ng.IAnchorScrollService,
            $scope: ng.IScope,
            $rootScope: ng.IRootScopeService,
            processConfigurationService: services.ProcessConfigurationService,
            processTypeService: services.ProcessTypeService,
            workflowService: services.WorkflowService,
            workflowDrawingService: services.WorkflowDrawingService,
            conditionService: services.ConditionService,
            emailConfigurationService: services.EmailConfigurationService,
            pdfBindingService: services.PdfBindingService,
            modalService: any)
        {
            this.processConfigId = processConfigId;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.statusGroups = [];

            this.processConfigurationService = processConfigurationService;
            this.processTypeService = processTypeService;
            this.workflowService = workflowService;
            this.workflowDrawingService = workflowDrawingService;
            this.conditionService = conditionService;
            this.emailConfigurationService = emailConfigurationService;
            this.pdfBindingService = pdfBindingService;

            this.modalService = modalService;
            //this.loadProcessConfiguration();
            this.loadWorkflowData();
            this.loadConditions();
            this.loadEmailConfigurations();
            this.loadPdfBindings();

            if (anchor) this.gotoAnchor(anchor);
        }

        public gotoAnchor(anchorId: string) {
            var old = this.$location.hash();
            this.$location.hash(anchorId);
            this.$anchorScroll();
            //reset to old to keep any additional routing logic from kicking in
            this.$location.hash(old);
        }

        public getDataTypeByFieldType(fieldType: Wars.Domain.Model.Codes.Enums.FieldType) : string {
            switch (fieldType) {
                case Wars.Domain.Model.Codes.Enums.FieldType.TextBox:
                case Wars.Domain.Model.Codes.Enums.FieldType.TextArea:
                
                    return "String";

                case Wars.Domain.Model.Codes.Enums.FieldType.CheckBox:
                    return "Boolean";

                case Wars.Domain.Model.Codes.Enums.FieldType.DocumentUpload:
                    return "Document";
                    
                case Wars.Domain.Model.Codes.Enums.FieldType.Date:
                    return "Date/Time";
                 
                case Wars.Domain.Model.Codes.Enums.FieldType.Dropdown:
                case Wars.Domain.Model.Codes.Enums.FieldType.RadioButton:
                    return "Code";

                case Wars.Domain.Model.Codes.Enums.FieldType.PhoneNumber:
                    return "Phone Number";   

                case Wars.Domain.Model.Codes.Enums.FieldType.RichText: 
                case Wars.Domain.Model.Codes.Enums.FieldType.Label:
                    return "Informative Label";

                case Wars.Domain.Model.Codes.Enums.FieldType.Location:
                    return "Location";

                case Wars.Domain.Model.Codes.Enums.FieldType.Number:
                    return "Number";

                case Wars.Domain.Model.Codes.Enums.FieldType.Zipcode:
                    return "Zip Code";

                case Wars.Domain.Model.Codes.Enums.FieldType.Time:
                    return "Time";

                case Wars.Domain.Model.Codes.Enums.FieldType.Currency:
                    return "Currency";

                case Wars.Domain.Model.Codes.Enums.FieldType.Url:
                    return "Url";

                case Wars.Domain.Model.Codes.Enums.FieldType.EmailAddress:
                    return "Email Address";

                case Wars.Domain.Model.Codes.Enums.FieldType.Percentage:
                    return "Percentage";

                default:
                    return "Unknown";
            }
        }

        public getConditionNameForField(field: Wars.Domain.Model.Field): string {
            if (!field || !field.condition_id) return "N/A";
            var condition = this.getConditionById(field.condition_id);
            if (condition) return condition.name;
            return "N/A";
        }

        public getDisplayConditions(step: Wars.Domain.Model.FormStep) {
            var stepConditions: Wars.Domain.Model.Conditions.Condition[] = [];
            var ids: string[] = [];
            var match: Wars.Domain.Model.Conditions.Condition;

            if (step.condition_id != null) {
                match = Enumerable.from(this.conditions).singleOrDefault(i => i.id == step.condition_id);
                if (match) {
                    stepConditions.push(match);
                    ids.push(match.id);
                }
            }

            for (var i = 0; i < step.formSections.length; i++) {
                var formSection = step.formSections[i];
                if (formSection.condition_id != null) {
                    match = Enumerable.from(this.conditions).singleOrDefault(i => i.id == formSection.condition_id);
                    if (match && ids.indexOf(match.id) === -1) {
                        stepConditions.push(match);
                        ids.push(match.id);
                    }
                }

                for (var x = 0; x < formSection.fields.length; x++) {
                    var field = formSection.fields[x];
                    if (field.condition_id != null) {
                        match = Enumerable.from(this.conditions).singleOrDefault(i => i.id == field.condition_id);
                        if (match && ids.indexOf(match.id) === -1) {
                            stepConditions.push(match);
                            ids.push(match.id);
                        }
                    }
                }
            }

            if (stepConditions.length > 0) {
                //debugger;
            }
            return stepConditions;
        }

        public isCode(value: Wars.Domain.Model.Field): boolean {
            return value && (value.type === Wars.Domain.Model.Codes.Enums.FieldType.Dropdown || value.type === Wars.Domain.Model.Codes.Enums.FieldType.RadioButton);
        }

        public getOptions(field: Wars.Domain.Model.Field): string[] {
            var options = [];
            if (field.schemaProperty.codeGroup) {
                options = Enumerable.from(field.schemaProperty.codeGroup.codes).select(i => i.shortDescription).toArray();
            }

            return options;
        }

        //private loadProcessConfiguration(): void {
        //    this.processConfigurationService.getProcessConfigurationTree(this.processConfigId)
        //        .then(
        //        (processConfig) => {
        //            this.processConfiguration = processConfig
        //            this.processTypeService.getProcessTypeById(processConfig.processType_id).then(
        //                (processType) => {
        //                    this.processType = processType;
        //                });
        //        });
        //}

        private loadConditions(): void {
            this.conditionService.getAllConditionsEagerLoadExpression(this.processConfigId).then((conditions) => this.conditions = conditions);
        }

        private loadEmailConfigurations(): void {
            this.emailConfigurationService.getAllEmailConfigurationsByProcessId(this.processConfigId).then((emailConfigurations) => this.emailConfigurations = emailConfigurations);
        }

        private loadPdfBindings(): void {
            this.pdfBindingService.getPdfBindings(this.processConfigId).then((pdfBindings) => this.pdfBindings = pdfBindings);
        }

        private loadWorkflowData(): void {
            var self = this;

            this.workflowService.getAllStatusGroupsWithAdditionalInfo(this.processConfigId)
                .then((processStatusGroupResult) => {
                    self.processStatusGroupResult = processStatusGroupResult;
                    self.statusGroups = [];
                    for (var i = 0; i < this.processStatusGroupResult.processStatusGroups.length; i++) {
                        self.statusGroups.push(new StatusGroup(this.processStatusGroupResult.processStatusGroups[i]));
                    }
                    setTimeout(() => this.drawWorkflowDiagrams());
                });
        }

        private drawWorkflowDiagrams(): void {
            
            for (var i = 0; i < this.processStatusGroupResult.processStatusGroups.length; i++) {
                var settings = new WorkflowDrawingSettings(1136, 639);

                var svgId = 'diagram_' + (i + 1);
                var drawingInstance = new models.WorkflowDrawingInstance(
                    svgId,
                    this.workflowService,
                    this.workflowDrawingService,
                    settings,
                    this.$scope,
                    this.$rootScope,
                    undefined,
                    undefined,
                    this.modalService);

                drawingInstance.initializeData(this.processConfigId, this.processStatusGroupResult.isReadonly);

                var blocks = this.processStatusGroupResult.processStatusGroups[i].workflowBlocks;
                var initialBlock = Enumerable.from(blocks).single(i => i.isInitialBlock);

                for (var x = 0; x < this.processStatusGroupResult.processStatusGroups[i].workflowBlocks.length; x++) {
                    this.processStatusGroupResult.processStatusGroups[i].workflowBlocks[x].setDrawingInstance(drawingInstance);
                }

                var maxCoordinates = drawingInstance.drawModel(initialBlock);

                this.$scope.$apply(() => {
                    this.zoomAsNecessary(drawingInstance, settings, maxCoordinates, initialBlock);

                    for (var x = 0; x < blocks.length; x++) {
                        if (blocks[x].type == Wars.Domain.Model.Codes.Enums.BlockType.Goto) {
                            (<GotoWorkflowBlock>blocks[x]).hoverStart();
                        }
                    }
                });

                
            }
        }

        private zoomAsNecessary(drawingInstance: WorkflowDrawingInstance, settings: WorkflowDrawingSettings, maxDrawingCoordinate: Coordinate, exampleBlock: IWorkflowBlock) : void {
            var drawingWidth = (maxDrawingCoordinate.x + 1) * exampleBlock.blockWidth;
            var drawingHeight = (maxDrawingCoordinate.y + 1) * exampleBlock.blockHeight;

            var zoomPercentageHeight = settings.getZoomPercentageFromViewBoxHeight(drawingHeight);
            var zoomPercentageWidth = settings.getZoomPercentageFromViewBoxWidth(drawingWidth);

            settings.zoomPercentage = Math.min(zoomPercentageHeight, zoomPercentageWidth);

            this.workflowDrawingService.changeViewBoxSizeAndOffset(
                drawingInstance.paper,
                drawingInstance.settings.xOrigin,
                drawingInstance.settings.yOrigin,
                settings.getViewBoxWidth(),
                settings.getViewBoxHeight());
        }

        public getConditionById(id: string): Wars.Domain.Model.Conditions.Condition {
            if (!this.conditions) return undefined;
            return Enumerable.from(this.conditions).singleOrDefault(i => i.id == id);
        }
    }
}